module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HgEKN7/cover.jpeg?1684229399446",
      "alt": "This image is the cover for the book Mr. President Pampers His Little Wife, Volume 4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mr. President Pampers His Little Wife, Volume 4\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("In order to repay the debt her mother owed her, she had come to pay them, and had suffered all the humiliation and torment, from being a daughter to being a lowly maid.")])]), _c('p', [_vm._v("He loved and hated her, and the pleasure of revenge clouded his eyes and blinded his heart.")]), _c('p', [_vm._v("\"Big Bro, can you not be so hypocritical?\"")]), _c('p', [_vm._v("\"No matter, taking care of me is your responsibility!\"")]), _c('p', [_vm._v("The president of the black department is ruthless and ruthless, but he is also a villain...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Guo ZiYuan, Lemon Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0